import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import { auth } from "./firebase";
import { resolveInitialLang, readStoredLang, writeStoredLang, type Lang, FALLBACK_LANG } from "./lib/lang";

const resources = {
  en: { translation: en },
  es: { translation: es },
};

const searchParam = new URLSearchParams(window.location.search).get("lang");
const initialLang = resolveInitialLang({
  searchParam,
  storedLang: readStoredLang(),
  navigatorLang: typeof navigator !== "undefined" ? navigator.language : "",
});

writeStoredLang(initialLang);

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: FALLBACK_LANG,
  interpolation: { escapeValue: false },
});

document.documentElement.setAttribute("lang", initialLang);
// Force Firebase Auth's verification + password-reset emails to render in English
// regardless of UI language. Firebase Console only supports a single template
// language (set in the global dropdown there), so syncing with i18n would lead
// to inconsistent mails. Owner chose English as the universal sender language.
auth.languageCode = "en";
i18n.on("languageChanged", (lng: string) => {
  document.documentElement.setAttribute("lang", lng);
  writeStoredLang(lng as Lang);
});

export default i18n;
